module.exports = __webpack_public_path__ + "media/content-creator/mobile-pets-1-14547fc7.png";